export default "__VITE_ASSET__BDzX4NH$__"